<template>
  <section class="row px-2">
    <div class="col-12 text-center mb-md-5">
      <h3 v-if="needHelpToFinalize">
        Nous allons vous aider à finaliser votre modification !
      </h3>
      <h3 v-else>
        Félicitations, votre modification a été prise en compte !
      </h3>
    </div>
    <div class="col-12 text-center">
      <img
        class="img-fluid"
        :src="`${aws}/unicorn-party.png`"
      >
    </div>
    <div class="col-12 col-md-8 mx-auto text-center mt-3 mt-md-6 mb-md-3">
      <p v-if="type === 'monthly'">
        Vous avez choisi un fractionnement mensuel de
        votre prime, vous serez donc directement prélevé
        sur vos prochaines échéances.
      </p>
      <p v-else>
        Vous avez choisi un fractionnement annuel de
        votre prime, vous serez donc directement prélevé du
        montant de votre modification.
      </p>
    </div>
    <v-timer
      :seconds="seconds"
    />
  </section>
</template>
<script>
import Timer from '../customisation/Timer.vue';

export default {
  name: 'AmendmentConfirmation',
  components: {
    'v-timer': Timer,
  },
  data() {
    return {
      path: 'https://app.assurup.com/login',
      needHelpToFinalize: false,
      counter: 0,
      seconds: 15,
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    type() {
      return this.$route.query.type;
    },
  },
  beforeUnmount() {
    this.$store.dispatch('company/getDocumentsToBeSigned');
  },
  mounted() {
    this.counter = setInterval(() => {
      this.seconds -= 1;
      if (this.seconds === -1) {
        this.replaceRoute();
      }
    }, 1000);
  },
  methods: {
    async replaceRoute() {
      await this.$router.replace('/client');
      this.$router.go(0);
    },
  },
};
</script>
